import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { FlexContainer, Paragraph, Button, EMail, TrashCan } from 'heliocor-ui'
import 'styled-components/macro'

import { REQUEST_RESET_CUSTOMER_DATA } from '../../store/cafe/actionTypes'

import { WarningBox } from '../WarningBox'
import { IconButton } from '@material-ui/core'


const SupportEmail = ({ asIcon, supportEmail }) => {

    const { t } = useTranslation()
    const [emailWarning, setEmailWarning] = useState(false)

    const customColors = useSelector(store => store.settings.colors || {})

    const EmailIcon = () =>
        <IconButton onClick={() => setEmailWarning(true)}>
            <EMail fill={customColors.mainColor} size='12px' margin='0 .25rem 0' />
        </IconButton>

    const EmailButton = ({ type }) =>
        <Button
            fixDimension={{height: '32px'}}
            type={type}
            onClick={() => setEmailWarning(true)}
            size='small'
            value={<div css='display:flex'>
                <EMail size='12px' margin='0 .25rem 0' fill={customColors.mainColor} />
                <span>{t("button.support")}</span>
            </div>}
        />

    return (
        <>
            {asIcon ? <EmailIcon /> : <EmailButton type='light' />}
            <WarningBox
                open={emailWarning}
                title={t('contactSupport')}
                onClose={() => setEmailWarning(false)}
                content={<Paragraph value={t('warning.contactSupport', { email: supportEmail })} />}
                buttons={[{
                    type: 'html',
                    onClick: `mailto:${supportEmail}`,
                    value: t('button.support'),
                    autoFocus: true
                }, {
                    type: 'light',
                    onClick: () => setEmailWarning(false),
                    value: t('button.cancel'),
                    margin: '0 1rem'
                }]}
            />
        </>
    )
}

const SaveAndReset = ({ saveDataToStore, asIcon }) => {

    const { t } = useTranslation()
    const [resetAppModal, setResetAppModal] = useState(false)

    const dispatch = useDispatch()

    const resetData = () => dispatch({ type: REQUEST_RESET_CUSTOMER_DATA })

    const resetApp = () => {
        resetData()
        setResetAppModal(false)
    }

    const warningBoxes = [
        {   
            id: "resetAppModal",
            open: resetAppModal,
            title: t('resetApp'),
            onClose: () => setResetAppModal(false),
            content: t('warning.resetApp'),
            buttons: [{
                type: 'default',
                id: 'warningContinue',
                onClick: () => resetApp(),
                value: t('button.continue'),
                autoFocus: true
            }, {
                type: 'light',
                margin: '0 1rem',
                id: 'warningCancel',
                onClick: () => setResetAppModal(false),
                value: t('button.cancel')
            }]
        }
    ]

    return (
        <>
            {asIcon
                ? <FlexContainer>
                    <IconButton onClick={() => setResetAppModal(true)}>
                        <TrashCan size='12px' margin='0 .25rem 0' />
                    </IconButton>
                </FlexContainer>
                : <FlexContainer column>
                    <Button 
                        size='small'
                        type='light'
                        data-cy='resetApp'
                        value={t('resetApp')}
                        fixDimension={{ width: '100%', height: '32px' }}
                        onClick={() => setResetAppModal(true)}
                    />
                </FlexContainer>
            }
            {warningBoxes.map((warn, index) => (
                <WarningBox
                    key={index}
                    id={warn.id}
                    open={warn.open}
                    title={warn.title}
                    onClose={warn.onClose}
                    content={warn.content}
                    buttons={warn.buttons}
                />
            ))}
        </>
    )
}

export { SaveAndReset, SupportEmail }